// Parcel inlines process.env.NODE_ENV at build time ("production" for
// `parcel build`, "development" for the dev server), so this collapses to a
// literal true/false in the bundle and telemetry only leaves the browser from a
// production build. There is no `process` object at runtime - do NOT add a
// `declare const process` here: that makes Parcel treat it as a local binding,
// skip the substitution, and the bundle then throws "process is not defined".
// The type comes from @types/node in the repo root.
const IS_PRODUCTION = process.env.NODE_ENV === "production";

const baudrates = document.getElementById("baudrates") as HTMLSelectElement;
const firmwareVersion = document.getElementById("firmwareVersion") as HTMLSelectElement;
const connectButton = document.getElementById("connectButton") as HTMLButtonElement;
const manualConnectButton = document.getElementById("manualConnectButton") as HTMLButtonElement;
const disconnectButton = document.getElementById("disconnectButton") as HTMLButtonElement;
const forceDisconnectButton = document.getElementById("forceDisconnectButton") as HTMLButtonElement;
const eraseFlashButton = document.getElementById("eraseFlashButton") as HTMLButtonElement;
const boardStatus = document.getElementById("boardStatus") as HTMLSpanElement;
const boardNameWarning = document.getElementById("boardNameWarning") as HTMLSpanElement;
const connectionStatus = document.getElementById("connectionStatus") as HTMLSpanElement;
const firmwareVersionDisplay = document.getElementById("firmwareVersionDisplay") as HTMLSpanElement;
const firmwareVersionLine = document.getElementById("firmwareVersionLine") as HTMLDivElement;
const macAddress = document.getElementById("macAddress") as HTMLSpanElement;
const macAddressLine = document.getElementById("macAddressLine") as HTMLDivElement;
const step1 = document.getElementById("step1") as HTMLDivElement;
const step2 = document.getElementById("step2") as HTMLDivElement;
const advancedToggle = document.getElementById("advancedToggle") as HTMLDivElement;
const advancedContent = document.getElementById("advancedContent") as HTMLDivElement;
const advancedArrow = document.getElementById("advancedArrow") as HTMLSpanElement;
const boardNameInput = document.getElementById("boardName") as HTMLInputElement;
const changeNameButton = document.getElementById("changeNameButton") as HTMLButtonElement;
const changeNameButtonContainer = document.getElementById("changeNameButtonContainer") as HTMLDivElement;
const boardNameEditSection = document.getElementById("boardNameEditSection") as HTMLDivElement;
const firmwareActionSection = document.getElementById("firmwareActionSection") as HTMLDivElement;
const flashFirmwareButton = document.getElementById("flashFirmwareButton") as HTMLButtonElement;
const bulkModeToggle = document.getElementById("bulkModeToggle") as HTMLInputElement;
const bulkModeControls = document.getElementById("bulkModeControls") as HTMLDivElement;
const bulkStartSuffix = document.getElementById("bulkStartSuffix") as HTMLInputElement;
const bulkNextName = document.getElementById("bulkNextName") as HTMLSpanElement;
const bulkBanner = document.getElementById("bulkBanner") as HTMLDivElement;
const bulkBannerName = document.getElementById("bulkBannerName") as HTMLSpanElement;
const bulkLastFlashedName = document.getElementById("bulkLastFlashedName") as HTMLElement;
const bulkLastFlashedMeta = document.getElementById("bulkLastFlashedMeta") as HTMLSpanElement;
const bulkLastFlashedRefresh = document.getElementById("bulkLastFlashedRefresh") as HTMLButtonElement;
const bulkStartWarning = document.getElementById("bulkStartWarning") as HTMLDivElement;
const bulkStartWarningText = document.getElementById("bulkStartWarningText") as HTMLSpanElement;
const bulkStartSuggestionApply = document.getElementById("bulkStartSuggestionApply") as HTMLButtonElement;
const terminal = document.getElementById("terminal");
const feedbackContent = document.getElementById("feedbackContent") as HTMLDivElement;
const feedbackHelp = document.getElementById("feedbackHelp") as HTMLDivElement;
const programDiv = document.getElementById("program");
const lblBaudrate = document.getElementById("lblBaudrate");
const lblConnTo = document.getElementById("lblConnTo");
const alertDiv = document.getElementById("alertDiv");

// Progress bar elements
const progressSection = document.getElementById("progressSection") as HTMLDivElement;
const progressBar = document.getElementById("progressBar") as HTMLDivElement;
const progressOverall = document.getElementById("progressOverall") as HTMLSpanElement;
const stepStart = document.getElementById("step-start") as HTMLDivElement;
const stepErasing = document.getElementById("step-erasing") as HTMLDivElement;
const stepUpdating = document.getElementById("step-updating") as HTMLDivElement;
const stepWriting = document.getElementById("step-writing") as HTMLDivElement;
const stepStartPercent = document.getElementById("step-start-percent") as HTMLSpanElement;
const stepErasingPercent = document.getElementById("step-erasing-percent") as HTMLSpanElement;
const stepUpdatingPercent = document.getElementById("step-updating-percent") as HTMLSpanElement;
const stepWritingPercent = document.getElementById("step-writing-percent") as HTMLSpanElement;


// This is a frontend example of Esptool-JS using local bundle file
// To optimize use a CDN hosted version like
// https://unpkg.com/esptool-js@0.5.0/bundle.js
import { ESPLoader, FlashOptions, LoaderOptions, Transport } from "../../../lib";
import { serial } from "web-serial-polyfill";
import latest_binaryFileUrl from 'url:./v1_3_4_release_stickem_main_merged.bin?url';
import v1_3_3_binaryFileUrl from 'url:./v1_3_3_release_stickem_main_merged.bin?url';
import v1_3_2_binaryFileUrl from 'url:./v1_3_2_release_stickem_main_merged.bin?url';
import dev_binaryFileUrl from 'url:./v1_3_3_beta_2_stickem_main_merged.bin?url';
import v1_2_0_binaryFileUrl from 'url:./v1_2_0_stickem_main_merged.bin?url';
import v1_1_2_binaryFileUrl from 'url:./v1_1_2_stickem_main_merged.bin?url';
import v1_1_1_binaryFileUrl from 'url:./v1_1_1_stickem_main_merged.bin?url';
import v1_0_0_binaryFileUrl from 'url:./v1_0_0_stickem_main_merged.bin?url';
import connectionDialogUrl from 'url:./Connection_Dialog.png?url';

// Firmware version configuration
interface FirmwareVersion {
  value: string;
  label: string;
  binaryUrl: string;
  description?: string;
}

const firmwareVersions: FirmwareVersion[] = [
  {
    value: "v1.3.4",
    label: "Latest (v1.3.4)",
    binaryUrl: latest_binaryFileUrl, // Use the current binary for latest
    description: "Latest stable release with all bug fixes and features"
  },
  {
    value: "v1.3.3",
    label: "v1.3.3",
    binaryUrl: v1_3_3_binaryFileUrl,
    description: "Previous minor version"
  },
  {
    value: "v1.3.2",
    label: "v1.3.2",
    binaryUrl: v1_3_2_binaryFileUrl,
    description: "Older minor version"
  },
  {
    value: "v1.2.0",
    label: "v1.2.0",
    binaryUrl: v1_2_0_binaryFileUrl,
    description: "Previous major version"
  },
  {
    value: "v1.1.2",
    label: "v1.1.2",
    binaryUrl: v1_1_2_binaryFileUrl,
    description: "Previous version with fix for task returning crash"
  },
  {
    value: "v1.1.1",
    label: "v1.1.1",
    binaryUrl: v1_1_1_binaryFileUrl,
    description: "Previous version with possible crash from task deletion"
  },
  {
    value: "v1.0.0",
    label: "v1.0.0",
    binaryUrl: v1_0_0_binaryFileUrl,
    description: "Initial firmware version, has memory leak bug and only has hardcoded name"
  }
];

// Check Web Serial API support after DOM elements are defined
function checkWebSerialSupport() {
  if (!('serial' in navigator)) {
    const alertDiv = document.getElementById("alertDiv");
    const alertMsg = document.getElementById("alertmsg");
    alertMsg.textContent = "Web Serial API is not supported in this browser. Please use Chrome, Edge, or another Chromium-based browser.";
    alertDiv.style.display = "block";

    // Update feedback to show the error
    updateFeedback("Browser not supported - please use Chrome or Edge", 'error', false);

    // Disable connect functionality
    connectButton.disabled = true;
    connectButton.title = "Web Serial API not supported";
    manualConnectButton.disabled = true;
    manualConnectButton.title = "Web Serial API not supported";
  }
}

const serialLib = !navigator.serial && navigator.usb ? serial : navigator.serial;

declare let Terminal; // Terminal is imported in HTML script
declare let CryptoJS; // CryptoJS is imported in HTML script

const term = new Terminal({ cols: 60, rows: 30 });
term.open(terminal);

let device = null;
let serialDevice = null; // Store the original serial device separately
let transport: Transport;
let chip: string = null;
let esploader: ESPLoader;
let defaultBinaryData: string = null;
let currentFirmwareVersion: string = "v1.3.2"; // Track currently loaded version (NEW firmware to flash)
let oldFirmwareVersion: string = null; // Store old firmware version from device
let originalBoardName: string = null; // Store original name for cancel functionality
let currentBoardName: string = null; // Store current/auto-saved name
let currentMacAddress: string = null; // Store board MAC address
let boardIsUnnamed: boolean = false; // Track if board had no auto-detected name

// Bulk flash mode state
let bulkModeEnabled: boolean = false; // Whether bulk flash mode is toggled on
let bulkCurrentName: string | null = null; // Next name to write when bulk mode is on

disconnectButton.style.display = "none";
// Board name section is hidden by default in HTML

// Board status management
function updateBoardStatus(status: string, isConnected: boolean = false, isUnnamed: boolean = false, showWarning: boolean = false) {
  boardStatus.textContent = status;

  // Update board status styling
  boardStatus.classList.remove("disconnected", "connected", "unnamed");

  if (!isConnected) {
    boardStatus.classList.add("disconnected");
    boardNameWarning.style.display = "none";
  } else if (isUnnamed) {
    boardStatus.classList.add("unnamed");
    boardNameWarning.style.display = showWarning ? "inline" : "none";
  } else {
    boardStatus.classList.add("connected");
    boardNameWarning.style.display = "none";
  }
}

// Connection status management
function updateConnectionStatus(isConnected: boolean = false) {
  if (isConnected) {
    connectionStatus.textContent = "Connected";
    connectionStatus.classList.remove("disconnected");
    connectionStatus.classList.add("connected");
    // Show change board name button when connected
    changeNameButtonContainer.classList.add("show");
  } else {
    connectionStatus.textContent = "Disconnected";
    connectionStatus.classList.remove("connected");
    connectionStatus.classList.add("disconnected");
    // Hide change board name button when disconnected
    changeNameButtonContainer.classList.remove("show");
  }
}

function updateFlashButtonState() {
  if (!currentBoardName) {
    flashFirmwareButton.disabled = true;
    flashFirmwareButton.title = "Enter a board name to continue";
    boardNameEditSection.classList.add("name-required");
  } else {
    flashFirmwareButton.disabled = false;
    flashFirmwareButton.title = "";
    boardNameEditSection.classList.remove("name-required");
  }
}

// Progress bar management
interface ProgressState {
  currentStep: number;
  stepProgress: number[];
  overallProgress: number;
}

let progressState: ProgressState = {
  currentStep: 0,
  stepProgress: [0, 0, 0, 0],
  overallProgress: 0
};

function showProgressBar() {
  progressSection.style.display = 'block';
  resetProgress();

  // Hide main UI containers during firmware update to focus on progress
  const statusBoardDisplay = document.querySelector('.status-board-display') as HTMLElement;

  // Hide specific elements within steps-grid but keep the grid itself for progress bar
  step1.style.display = 'none';
  step2.style.display = 'none';
  const stepArrow = document.querySelector('.step-arrow') as HTMLElement;
  const action1Grid = document.querySelector('.action1-grid') as HTMLElement;
  const action2Grid = document.querySelector('.action2-grid') as HTMLElement;

  if (statusBoardDisplay) statusBoardDisplay.style.display = 'none';
  if (stepArrow) stepArrow.style.display = 'none';
  if (action1Grid) action1Grid.style.display = 'none';
  if (action2Grid) action2Grid.style.display = 'none';
}

function hideProgressBar() {
  progressSection.style.display = 'none';
  resetProgress();

  // Restore main UI containers after firmware update
  const statusBoardDisplay = document.querySelector('.status-board-display') as HTMLElement;

  // Restore specific elements within steps-grid
  step1.style.display = '';
  step2.style.display = '';
  const stepArrow = document.querySelector('.step-arrow') as HTMLElement;
  const action1Grid = document.querySelector('.action1-grid') as HTMLElement;
  const action2Grid = document.querySelector('.action2-grid') as HTMLElement;

  if (statusBoardDisplay) statusBoardDisplay.style.display = '';
  if (stepArrow) stepArrow.style.display = '';
  if (action1Grid) action1Grid.style.display = '';
  // Don't restore action2Grid (firmwareActionSection) if we're disconnecting
  // This will be handled separately in the disconnect flow
}

function resetProgress() {
  progressState = {
    currentStep: 0,
    stepProgress: [0, 0, 0, 0],
    overallProgress: 0
  };
  updateProgressDisplay();
}

function updateProgress(step: number, stepPercent: number) {
  // Update the specific step progress
  progressState.stepProgress[step] = Math.min(100, Math.max(0, stepPercent));

  // Calculate overall progress (each step is 25%)
  let overall = 0;
  for (let i = 0; i < 4; i++) {
    if (i < step) {
      overall += 25; // Completed steps
    } else if (i === step) {
      overall += (progressState.stepProgress[i] * 25) / 100; // Current step
    }
    // Future steps contribute 0
  }

  progressState.currentStep = step;
  progressState.overallProgress = Math.min(100, overall);

  updateProgressDisplay();
}

function updateProgressDisplay() {
  const steps = [stepStart, stepErasing, stepUpdating, stepWriting];
  const percentElements = [stepStartPercent, stepErasingPercent, stepUpdatingPercent, stepWritingPercent];

  // Update overall progress
  progressOverall.textContent = `${Math.round(progressState.overallProgress)}%`;
  progressBar.style.width = `${progressState.overallProgress}%`;

  // Update step states
  steps.forEach((step, index) => {
    step.classList.remove('active', 'completed');

    if (index < progressState.currentStep) {
      step.classList.add('completed');
      percentElements[index].textContent = '100%';
    } else if (index === progressState.currentStep) {
      step.classList.add('active');
      percentElements[index].textContent = `${Math.round(progressState.stepProgress[index])}%`;
    } else {
      percentElements[index].textContent = '0%';
    }
  });
}

// Feedback management
function updateFeedback(message: string, type: 'default' | 'connecting' | 'connected' | 'flashing' | 'error' = 'default', showHelp: boolean = false) {
  feedbackContent.textContent = message;

  // Remove all type classes
  feedbackContent.classList.remove('connecting', 'connected', 'flashing', 'error');

  // Add the appropriate type class
  if (type !== 'default') {
    feedbackContent.classList.add(type);
  }

  // Show or hide help text
  if (showHelp) {
    feedbackHelp.style.display = 'block';
  } else {
    feedbackHelp.style.display = 'none';
  }
}

// Step focus management
function focusStep(stepNumber: number) {
  if (stepNumber === 1) {
    step1.classList.remove("unfocused");
    step1.classList.add("focused");
    step2.classList.remove("focused");
    step2.classList.add("unfocused");
  } else if (stepNumber === 2) {
    step1.classList.remove("focused");
    step1.classList.add("unfocused");
    step2.classList.remove("unfocused");
    step2.classList.add("focused");
  }
}

// Advanced options dropdown management
function toggleAdvancedOptions() {
  const isExpanded = advancedContent.classList.contains("show");

  if (isExpanded) {
    advancedContent.classList.remove("show");
    advancedArrow.classList.remove("expanded");
  } else {
    advancedContent.classList.add("show");
    advancedArrow.classList.add("expanded");
  }
}

// Board name editing management
function showBoardNameEdit() {
  changeNameButtonContainer.classList.remove("show");
  boardNameEditSection.classList.add("show");
  // Store the original name for cancel functionality
  originalBoardName = boardStatus.textContent && boardStatus.textContent !== "No Board Detected" ? boardStatus.textContent : "";

  let nameToShow: string;
  if (boardIsUnnamed) {
    nameToShow = currentBoardName || "";
    boardNameInput.disabled = false;
  } else if (currentBoardName !== null) {
    nameToShow = currentBoardName;
  } else if (originalBoardName) {
    nameToShow = originalBoardName;
  } else {
    nameToShow = "";
    currentBoardName = "";
  }

  boardNameInput.value = nameToShow;
}

function hideBoardNameEdit() {
  // Only show the button if we're actually connected
  if (connectionStatus.classList.contains("connected")) {
    changeNameButtonContainer.classList.add("show");
  }
  boardNameEditSection.classList.remove("show");
  boardNameInput.value = "";
}


// Add click event handlers
advancedToggle.onclick = toggleAdvancedOptions;
changeNameButton.onclick = showBoardNameEdit;

// ---------------------------------------------------------------------------
// Bulk flash mode
// ---------------------------------------------------------------------------

// Bulk names are always "Stick 'Em " + a single letter + a 3-digit number.
// The prefix is fixed by the UI; the operator only edits the letter/number part.
const BULK_NAME_PREFIX = "Stick 'Em ";

// ---------------------------------------------------------------------------
// "Last flashed board" lookup
// ---------------------------------------------------------------------------
//
// Reads back the most recent bulk-named row from the telemetry table so the
// operator can see where the previous run stopped before picking a start name.
// Read-only: this key is a Supabase anon key, so the table must expose SELECT
// to the `anon` role through an RLS policy and nothing else.

// TODO: paste the public Supabase anon key here (it is safe to ship - it only
// grants whatever the table's RLS policies allow the `anon` role to do).
const SUPABASE_ANON_KEY = "sb_publishable_IeCzNG6dhJOoJfblphpQ2Q_OOSNcMy2";// publishable key so ok to show

const LAST_BULK_FLASH_URL =
  "https://drkkumfxlfpthszaohfs.supabase.co/rest/v1/firmware_telemetry" +
  "?select=id%2Cmac_address%2Ccurrent_firmware_version%2Coriginal_name%2Cnew_firmware_version%2Cnew_name%2Cip_address%2Ccountry_code%2Ccountry%2Ccity%2Cregion%2Ccreated_at%2Cfrom_dev_page" +
  "&new_name=match.%5EStick+%27Em+%5BA-Z%5D%5B0-9%5D%7B3%7D" +
  "&current_firmware_version=eq.%3C+v1.1.1" +
  "&from_bulk_flashing=is.true" +
  "&order=created_at.desc.nullslast%2Cid.desc" +
  "&limit=11"; 

interface FirmwareTelemetryRow {
  id?: number;
  new_name?: string | null;
  new_firmware_version?: string | null;
  city?: string | null;
  country?: string | null;
  created_at?: string | null;
}

// Last board the database knows about, and the name that would follow it.
// Used to suggest a starting name when the operator hasn't set one.
let bulkLastFlashedRealName: string | null = null;
let bulkSuggestedName: string | null = null;

// Only one lookup in flight at a time - a flash finishing while the operator is
// mashing refresh should not leave a stale response painting over a fresh one.
// A request that arrives during a lookup is not dropped, it is re-run after
// (the post-flash refresh has to reflect the row that flash just created).
let lastFlashedLookupInFlight = false;
let lastFlashedLookupQueued = false;

function setLastFlashedDisplay(name: string, meta: string) {
  bulkLastFlashedName.textContent = name;
  bulkLastFlashedMeta.textContent = meta;
}

/**
 * Fetch the most recently flashed bulk board and show it above the start-name
 * field. Never throws and never blocks flashing - on any failure the panel just
 * says so.
 */
async function refreshLastFlashedBoard() {
  if (lastFlashedLookupInFlight) {
    lastFlashedLookupQueued = true;
    return;
  }

  lastFlashedLookupInFlight = true;
  bulkLastFlashedRefresh.disabled = true;
  setLastFlashedDisplay("…", "checking database");

  try {
    const url = SUPABASE_ANON_KEY
      ? `${LAST_BULK_FLASH_URL}&apikey=${encodeURIComponent(SUPABASE_ANON_KEY)}`
      : LAST_BULK_FLASH_URL;

    const response = await fetch(url, { headers: { Accept: "application/json" } });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const rows = (await response.json()) as FirmwareTelemetryRow[];
    const row = Array.isArray(rows) ? rows[0] : undefined;

    if (!row || !row.new_name) {
      setLastFlashedDisplay("—", "no bulk-flashed boards recorded yet");
      setBulkSuggestionFrom(null);
      return;
    }

    // Timestamp plus where it was flashed, when the row carries that.
    const parts: string[] = [];
    if (row.created_at) {
      const when = new Date(row.created_at);
      parts.push(isNaN(when.getTime()) ? row.created_at : when.toLocaleString());
    }
    const place = [row.city, row.country].filter(Boolean).join(", ");
    if (place) {
      parts.push(place);
    }

    setLastFlashedDisplay(row.new_name, parts.length > 0 ? `(${parts.join(" · ")})` : "");
    setBulkSuggestionFrom(row.new_name);
  } catch (error) {
    console.log("Failed to look up last flashed board:", error);
    setLastFlashedDisplay("—", "lookup unavailable");
    setBulkSuggestionFrom(null);
  } finally {
    lastFlashedLookupInFlight = false;
    bulkLastFlashedRefresh.disabled = false;

    if (lastFlashedLookupQueued) {
      lastFlashedLookupQueued = false;
      refreshLastFlashedBoard();
    }
  }
}

/**
 * Record what the database says was flashed last, and what should follow it.
 * A row whose name doesn't fit the bulk pattern yields no suggestion rather
 * than a nonsense one.
 */
function setBulkSuggestionFrom(lastFlashedName: string | null) {
  bulkLastFlashedRealName = lastFlashedName;
  bulkSuggestedName = null;

  if (lastFlashedName) {
    const next = incrementBulkName(lastFlashedName);
    if (isCompleteBulkSuffix(bulkSuffixFromName(next))) {
      bulkSuggestedName = next;
    }
  }

  updateBulkStartNameWarning();
}

// Render the warning box. `danger` marks the case that costs real money -
// a name that may already be on a shipped board.
function showBulkStartWarning(message: string, danger: boolean = false) {
  bulkStartWarningText.textContent = message;
  bulkStartWarning.classList.toggle("danger", danger);

  if (bulkSuggestedName) {
    bulkStartSuggestionApply.textContent = `Use ${bulkSuffixFromName(bulkSuggestedName)}`;
    bulkStartSuggestionApply.style.display = "inline-block";
  } else {
    bulkStartSuggestionApply.style.display = "none";
  }

  bulkStartWarning.style.display = "flex";
}

/**
 * Warn about the starting name in the two ways it can be wrong:
 *
 *  1. there isn't a usable one, so flashing is blocked - say why
 *  2. there is one, but it doesn't follow the last board the database recorded
 *
 * Case 2 is only a warning, never a block: skipping ahead to a new letter block
 * is a legitimate thing to do at the start of a run. But a name that is BEHIND
 * the database is flagged harder, because that name may already be on a board
 * that shipped.
 */
function updateBulkStartNameWarning() {
  if (!bulkModeEnabled) {
    bulkStartWarning.style.display = "none";
    return;
  }

  // 1. No usable name yet.
  if (!bulkCurrentName) {
    const typed = bulkStartSuffix.value.trim();
    const problem = typed.length === 0
      ? "No starting name set."
      : `"${typed}" isn't a complete name (needs a letter followed by 3 digits).`;

    if (bulkSuggestedName) {
      showBulkStartWarning(
        `⚠️ ${problem} Last board flashed was "${bulkLastFlashedRealName}", ` +
        `so the next one should be "${bulkSuggestedName}".`
      );
    } else {
      showBulkStartWarning(
        `⚠️ ${problem} Enter a letter followed by 3 digits (e.g. E123) before flashing.`
      );
    }
    return;
  }

  // 2. A name is set - does it follow on from the database?
  // Skipped while a lookup is running, so the moment between a flash advancing
  // the counter and the refresh landing doesn't flicker a false mismatch.
  const suggested = bulkSuggestedName;
  if (!suggested || bulkCurrentName === suggested || lastFlashedLookupInFlight) {
    bulkStartWarning.style.display = "none";
    return;
  }

  // Fixed-width names, so a string compare orders them correctly (F001 > E999).
  if (bulkCurrentName < suggested) {
    showBulkStartWarning(
      `⛔ "${bulkCurrentName}" is BEHIND the database - the last board flashed was ` +
      `"${bulkLastFlashedRealName}", so this name may already be on a board. ` +
      `Expected "${suggested}".`,
      true
    );
  } else {
    showBulkStartWarning(
      `⛔ "${bulkCurrentName}" skips ahead of the database - the last board flashed ` +
      `was "${bulkLastFlashedRealName}", so "${suggested}" was expected. ` +
      `Continue only if you meant to leave a gap.`,
      true
    );
  }
}

// Take the suggestion: fill the field and drive it through the normal path so
// the counter, the preview, the banner and the connected board all agree.
bulkStartSuggestionApply.onclick = () => {
  if (!bulkSuggestedName) return;

  bulkStartSuffix.value = bulkSuffixFromName(bulkSuggestedName);
  syncBulkNameFromSuffixField();
  updateBulkNextNameDisplay();
  if (connectionStatus.classList.contains("connected")) {
    applyBulkNameToCurrentBoard();
  }
};

bulkLastFlashedRefresh.onclick = () => {
  refreshLastFlashedBoard();
};

// Populate on page load so the last board is on screen before bulk mode is even
// switched on.
refreshLastFlashedBoard();

/**
 * Normalize whatever the operator typed into the suffix field: uppercase, drop
 * anything that isn't a letter/digit, and keep at most one leading letter
 * followed by up to 3 digits. Partial values (e.g. "E1") are allowed while typing.
 */
function sanitizeBulkSuffix(raw: string): string {
  const cleaned = raw.toUpperCase().replace(/[^A-Z0-9]/g, "");
  const match = cleaned.match(/^([A-Z])(\d{0,3})/);
  if (!match) {
    return "";
  }
  return `${match[1]}${match[2]}`;
}

// A suffix only drives a flash once it is complete: letter + exactly 3 digits.
function isCompleteBulkSuffix(suffix: string): boolean {
  return /^[A-Z]\d{3}$/.test(suffix);
}

// Strip the fixed prefix back off a full bulk name to get the editable part.
function bulkSuffixFromName(name: string): string {
  return name.startsWith(BULK_NAME_PREFIX) ? name.slice(BULK_NAME_PREFIX.length) : name;
}

/**
 * Increment a bulk board name that ends in a single letter + 3-digit number.
 * e.g. "Stick 'Em E123" -> "Stick 'Em E124", "Stick 'Em E999" -> "Stick 'Em F001".
 * When the letter passes Z (or z) it wraps back to A (or a).
 * Returns the name unchanged if it does not match the expected pattern.
 */
function incrementBulkName(name: string): string {
  const match = name.match(/^(.*?)([A-Za-z])(\d{3})$/);
  if (!match) {
    return name; // Pattern not recognized - leave untouched
  }

  const prefix = match[1];
  let letter = match[2];
  let num = parseInt(match[3], 10) + 1;

  if (num > 999) {
    num = 1;
    const isUpper = letter >= "A" && letter <= "Z";
    let nextCode = letter.charCodeAt(0) + 1;
    // Wrap Z -> A (or z -> a)
    if (isUpper && nextCode > "Z".charCodeAt(0)) nextCode = "A".charCodeAt(0);
    if (!isUpper && nextCode > "z".charCodeAt(0)) nextCode = "a".charCodeAt(0);
    letter = String.fromCharCode(nextCode);
  }

  return `${prefix}${letter}${String(num).padStart(3, "0")}`;
}

window.incrementBulkName = incrementBulkName;

// Refresh the "next board" preview and keep the flash button state in sync.
function updateBulkNextNameDisplay() {
  const displayName = bulkCurrentName && bulkCurrentName.length > 0 ? bulkCurrentName : "—";
  bulkNextName.textContent = displayName;
  // Keep the top-of-page banner in sync: visible only while bulk mode is on.
  bulkBanner.style.display = bulkModeEnabled ? "flex" : "none";
  bulkBannerName.textContent = displayName;
  // Every path that changes the counter comes through here, so this is the one
  // place the "no starting name" warning needs re-evaluating.
  updateBulkStartNameWarning();
}

// ---------------------------------------------------------------------------
// Bulk mode passcode
// ---------------------------------------------------------------------------
//
// A speed bump, not a security control. It stops someone casually switching on
// bulk mode and writing junk into the firmware tracker; it does NOT protect the
// telemetry endpoint, which accepts an unauthenticated POST from anywhere. The
// hash below ships in the bundle and can be attacked offline, so the passcode
// must be long and random - a short one is dictionary-cracked in seconds and
// the hash buys nothing over storing it in plain text.
//
// Set this to the SHA-256 (lowercase hex) of the passcode. Generate it with:
//   printf '%s' 'your-passcode' | shasum -a 256
// Leave it empty to disable the prompt entirely.
const BULK_PASSCODE_SHA256: string = "374365bbbf0166c69da1811f50c7efd62f76eb934fc696f98fbd612544074201";

// The passcode itself is remembered in localStorage and re-hashed on every use,
// rather than a "unlocked" flag - a flag could be forged by setting it in
// devtools, whereas forging this means knowing something that hashes to
// BULK_PASSCODE_SHA256. The cost is that the passcode sits in plaintext on that
// machine; acceptable here because it only ever goes to internal operators.
//
// Rotating BULK_PASSCODE_SHA256 invalidates every stored copy for free: the
// hash no longer matches, so everyone is asked again.
const BULK_UNLOCK_KEY = "stickem.bulkPasscode";

async function sha256Hex(text: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

async function bulkPasscodeMatches(candidate: string): Promise<boolean> {
  return (await sha256Hex(candidate)) === BULK_PASSCODE_SHA256.toLowerCase();
}

/**
 * Ask for the bulk passcode, unless a previously accepted one is remembered on
 * this machine and still hashes to the expected value.
 * Returns false if the operator cancels or gets it wrong.
 */
async function unlockBulkMode(): Promise<boolean> {
  if (!BULK_PASSCODE_SHA256) return true; // No passcode configured

  // A remembered passcode is re-hashed, never trusted on the strength of being
  // present. One that no longer matches (rotated passcode, edited by hand) is
  // dropped and the operator is asked again.
  try {
    const remembered = localStorage.getItem(BULK_UNLOCK_KEY);
    if (remembered) {
      if (await bulkPasscodeMatches(remembered)) return true;
      localStorage.removeItem(BULK_UNLOCK_KEY);
    }
  } catch (e) {
    // Storage can be unavailable (private mode); fall through and just ask.
  }

  const entered = prompt("Enter the bulk flash passcode:");
  if (entered === null) return false; // Cancelled

  if (!(await bulkPasscodeMatches(entered))) {
    alert("Incorrect passcode - bulk flash mode not enabled.");
    return false;
  }

  try {
    localStorage.setItem(BULK_UNLOCK_KEY, entered);
  } catch (e) {
    // Not fatal - the operator will just be asked again next time.
  }
  return true;
}

// Toggle bulk mode on/off
bulkModeToggle.onchange = async () => {
  // Gate switching bulk mode ON; switching it off never asks.
  if (bulkModeToggle.checked && !(await unlockBulkMode())) {
    bulkModeToggle.checked = false;
    return;
  }

  bulkModeEnabled = bulkModeToggle.checked;
  bulkModeControls.style.display = bulkModeEnabled ? "block" : "none";

  if (bulkModeEnabled) {
    // Seed the counter from the starting-suffix field
    syncBulkNameFromSuffixField();
    // Re-check the database so the operator starts from a current value
    refreshLastFlashedBoard();
    // If already connected, apply the bulk name to the current board immediately
    if (connectionStatus.classList.contains("connected")) {
      applyBulkNameToCurrentBoard();
    }
  } else {
    bulkCurrentName = null;
  }
  updateBulkNextNameDisplay();
};

// Browsers restore form-control state across a reload or a back/forward
// navigation, so the checkbox can come back checked on what looks like a fresh
// page while bulkModeEnabled is false and onchange never ran - leaving a ticked
// box, hidden controls, no banner, and a passcode prompt that never happened.
// Force the control to agree with the state above at startup.
bulkModeToggle.checked = false;
bulkModeControls.style.display = "none";
updateBulkNextNameDisplay();

// Read the suffix field, normalize it, and rebuild the full bulk name from the
// fixed prefix. An incomplete suffix leaves the counter unset.
function syncBulkNameFromSuffixField() {
  const suffix = sanitizeBulkSuffix(bulkStartSuffix.value);
  bulkStartSuffix.value = suffix;
  bulkCurrentName = isCompleteBulkSuffix(suffix) ? `${BULK_NAME_PREFIX}${suffix}` : null;
}

// Editing the starting suffix updates the counter (only meaningful before the
// first successful flash; after that the counter drives the value).
bulkStartSuffix.addEventListener("input", () => {
  if (!bulkModeEnabled) {
    bulkStartSuffix.value = sanitizeBulkSuffix(bulkStartSuffix.value);
    return;
  }
  syncBulkNameFromSuffixField();
  updateBulkNextNameDisplay();
  if (connectionStatus.classList.contains("connected")) {
    applyBulkNameToCurrentBoard();
  }
});

// Push the current bulk name onto the connected board's name field so a flash
// will write it. The name input is locked while bulk mode drives the value.
function applyBulkNameToCurrentBoard() {
  if (!bulkModeEnabled || !bulkCurrentName) return;
  currentBoardName = bulkCurrentName;
  boardNameInput.value = bulkCurrentName;
  boardNameInput.disabled = true;
  updateFlashButtonState();
}

// Add firmware version selection handler
firmwareVersion.onchange = async () => {
  const selectedVersion = firmwareVersion.value;
  const versionConfig = firmwareVersions.find(v => v.value === selectedVersion);

  if (versionConfig) {
    term.writeln(`Loading firmware version: ${versionConfig.label}`);
    const success = await loadBinaryFromUrl(versionConfig.binaryUrl);
    if (success) {
      term.writeln(`Successfully loaded ${versionConfig.label} firmware`);
      currentFirmwareVersion = selectedVersion;
    } else {
      term.writeln(`Failed to load ${versionConfig.label} firmware - keeping current version`);
      // Revert dropdown selection back to current version
      firmwareVersion.value = currentFirmwareVersion;
    }
  }
};
// Add auto-save functionality for board name input with byte length validation
let previousValue = '';
boardNameInput.addEventListener('input', (event) => {
  const encoder = new TextEncoder();
  const currentValue = boardNameInput.value;
  const nameBytes = encoder.encode(currentValue);

  // If the new value exceeds 31 bytes, reject the input and restore previous value
  if (nameBytes.length > 31) {
    boardNameInput.value = previousValue;
    console.log('Input rejected: would exceed 31 bytes (' + nameBytes.length + ' bytes)');
    return;
  }

  // Accept the input and update previous value
  previousValue = currentValue;

  // Auto-save the current name as the user types
  currentBoardName = currentValue.trim();

  updateFlashButtonState();

  console.log('Auto-saved board name:', currentBoardName, '(' + nameBytes.length + ' bytes)');
});

// Initialize previous value
boardNameInput.addEventListener('focus', () => {
  previousValue = boardNameInput.value;
});

// Flash firmware button should use the auto-saved board name
flashFirmwareButton.onclick = async () => {
  await flashFirmwareWithName();
};

// Load binary file from URL
async function loadBinaryFromUrl(url: string) {
  console.log("Loading binary from URL:", url);
  try {
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    // Convert to binary string
    let binaryString = '';
    for (let i = 0; i < uint8Array.length; i++) {
      binaryString += String.fromCharCode(uint8Array[i]);
    }
    defaultBinaryData = binaryString;
    return true;
  } catch (error) {
    console.error('Failed to load binary file from URL:', url, error);
    term.writeln(`Warning: Could not load binary file from ${url}`);
    return false;
  }
}

// Load default binary file
async function loadDefaultBinary() {
  const selectedVersion = firmwareVersion.value;
  const versionConfig = firmwareVersions.find(v => v.value === selectedVersion);
  const urlToLoad = versionConfig ? versionConfig.binaryUrl : latest_binaryFileUrl;

  await loadBinaryFromUrl(urlToLoad);
}

const espLoaderTerminal = {
  clean() {
    // Intentionally a no-op. The ESPLoader constructor calls clean() on every
    // instantiation, and a single connect flow builds several loaders (one per
    // baud-rate retry, plus the version-read reconnect). Clearing here would wipe
    // the debug log mid-connect. The terminal is cleared once explicitly at the
    // start of connectToDevice() instead — i.e. only when the user clicks Connect.
    //term.clear();
  },
  writeLine(data) {
    term.writeln(data);
  },
  write(data) {
    term.write(data);
  },
};

// ESP32 vendor and product IDs for automatic detection
const ESP32_FILTERS = [
  { usbVendorId: 0x10C4, usbProductId: 0xEA60 }, // Silicon Labs CP210x
  { usbVendorId: 0x1A86, usbProductId: 0x7523 }, // QinHeng Electronics CH340
  { usbVendorId: 0x0403, usbProductId: 0x6001 }, // FTDI FT232R
  { usbVendorId: 0x0403, usbProductId: 0x6014 }, // FTDI FT232H
  { usbVendorId: 0x239A, usbProductId: 0x80F4 }, // Adafruit Metro ESP32-S2
  { usbVendorId: 0x303A, usbProductId: 0x1001 }, // Espressif ESP32-S2
  { usbVendorId: 0x303A, usbProductId: 0x0002 }, // Espressif ESP32-S3
];

async function detectESP32Port() {
  try {
    // First check for already-paired ESP32 devices
    const availablePorts = await serialLib.getPorts();

    for (const port of availablePorts) {
      const info = port.getInfo();
      // Check if this port matches our ESP32 filters
      const isESP32 = ESP32_FILTERS.some(filter =>
        info.usbVendorId === filter.usbVendorId &&
        info.usbProductId === filter.usbProductId
      );

      if (isESP32) {
        // Test if the port is actually still valid before using it
        try {
          await port.open({ baudRate: 115200 });
          await port.close();
          term.writeln("Found previously paired ESP32 device - connecting automatically!");
          return port;
        } catch (testError) {
          term.writeln("Previously paired device no longer available, scanning for new devices...");
          continue; // Skip this stale port and continue checking others
        }
      }
    }

    // No paired ESP32 found, request new port with ESP32 filters
    term.writeln("No paired ESP32 found. Requesting new connection...");
    const port = await serialLib.requestPort({ filters: ESP32_FILTERS });
    term.writeln("ESP32 device detected and paired!");
    return port;
  } catch (e) {
    console.log("Auto-detection failed, falling back to manual selection:", e.message);
    term.writeln("Auto-detection failed. Please manually select the ESP32 port.");

    // Fallback to manual selection without filters
    try {
      const port = await serialLib.requestPort({});
      term.writeln("Port selected manually.");
      return port;
    } catch (manualError) {
      throw new Error("Port selection cancelled or failed");
    }
  }
}

async function readFirmwareVersion(): Promise<string | null> {
  if (!transport || !serialDevice) {
    return null;
  }

  try {
    term.writeln("Reading firmware version from device...");

    // Step 1: Temporarily disconnect from programming mode
    await transport.disconnect();

    // Step 2: Open serial port in normal mode to read output
    await serialDevice.open({ baudRate: 115200 });

    const reader = serialDevice.readable.getReader();
    let serialOutput = '';
    const startTime = Date.now();
    const timeout = 3000; // 3 second timeout

    // Step 3: Reset device to boot normally
    await serialDevice.setSignals({ dataTerminalReady: false });
    await new Promise(resolve => setTimeout(resolve, 100));
    await serialDevice.setSignals({ dataTerminalReady: true });

    // Step 4: Read serial output for firmware info with timeout
    let timeoutReached = false;

    while (!timeoutReached) {
      // Race between reading data and timeout
      const readPromise = reader.read();
      const timeoutPromise = new Promise<{ value: undefined, done: true }>((resolve) => {
        const remaining = timeout - (Date.now() - startTime);
        if (remaining <= 0) {
          timeoutReached = true;
          resolve({ value: undefined, done: true });
        } else {
          setTimeout(() => {
            timeoutReached = true;
            resolve({ value: undefined, done: true });
          }, remaining);
        }
      });

      const { value, done } = await Promise.race([readPromise, timeoutPromise]);

      if (timeoutReached || done) break;

      const text = new TextDecoder().decode(value);
      serialOutput += text;

      // Check if we found the firmware version (require newline at end to ensure complete version)
      const match = serialOutput.match(/Firmware Version:\s*([^\s\r\n]+)[\r\n]/);
      if (match) {
        let version = match[1];

        // Map date-based versions to actual version numbers
        const dateToVersionMap: { [key: string]: string } = {
          "03102025": "v1.1.2",
          "18082025": "v1.1.1"
        };

        if (dateToVersionMap[version]) {
          version = dateToVersionMap[version];
          term.writeln(`Found firmware version (mapped from date): ${version}`);
        } else {
          term.writeln(`Found firmware version: ${version}`);
        }

        reader.releaseLock();
        await serialDevice.close();

        // Step 5: Reconnect in programming mode
        transport = new Transport(serialDevice, true);
        const flashOptions = {
          transport,
          baudrate: parseInt(baudrates.value),
          terminal: espLoaderTerminal,
          debugLogging: true,
        } as LoaderOptions;
        esploader = new ESPLoader(flashOptions);
        chip = await esploader.main();

        return version;
      }
    }

    // Timeout - clean up and reconnect
    term.writeln("Could not detect firmware version from serial output");
    reader.releaseLock();
    await serialDevice.close();

    // Reconnect in programming mode
    transport = new Transport(serialDevice, true);
    const flashOptions = {
      transport,
      baudrate: parseInt(baudrates.value),
      terminal: espLoaderTerminal,
      debugLogging: true,
    } as LoaderOptions;
    esploader = new ESPLoader(flashOptions);
    chip = await esploader.main();

    return null;
  } catch (e) {
    console.error('Failed to read firmware version:', e);
    term.writeln("Warning: Could not read firmware version");

    // Try to reconnect in programming mode
    try {
      transport = new Transport(serialDevice, true);
      const flashOptions = {
        transport,
        baudrate: parseInt(baudrates.value),
        terminal: espLoaderTerminal,
        debugLogging: true,
      } as LoaderOptions;
      esploader = new ESPLoader(flashOptions);
      chip = await esploader.main();
    } catch (reconnectError) {
      console.error('Failed to reconnect:', reconnectError);
    }

    return null;
  }
}

async function readMacAddress(): Promise<string | null> {
  if (!esploader || !esploader.chip) {
    return null;
  }

  try {
    term.writeln("Reading MAC address...");
    const macAddr = await esploader.chip.readMac(esploader);
    term.writeln(`MAC address: ${macAddr}`);
    return macAddr;
  } catch (e) {
    console.error('Failed to read MAC address:', e);
    term.writeln("Warning: Could not read MAC address");
    return null;
  }
}

async function readExistingBoardName(): Promise<string | null> {
  if (!esploader) {
    return null;
  }

  // For v1.3.0 - v1.3.4: read directly from 0x310000
  if (oldFirmwareVersion === "v1.3.0" || oldFirmwareVersion === "v1.3.1" || oldFirmwareVersion === "v1.3.2" || oldFirmwareVersion === "v1.3.3" || oldFirmwareVersion === "v1.3.4") {
    try {
      term.writeln("Reading existing board name from 0x310000...");

      const nameData = await esploader.readFlash(0x310000, 32);

      // Convert Uint8Array to string and find null terminator
      let nameString = '';
      for (let i = 0; i < nameData.length; i++) {
        const byte = nameData[i];
        if (byte === 0) break; // Null terminator found
        nameString += String.fromCharCode(byte);
      }

      // Check if we got a valid name (not empty and printable characters)
      if (nameString.length > 0 && /^[\x20-\x7E]*$/.test(nameString)) {
        term.writeln(`Found existing name: "${nameString}"`);
        return nameString;
      } else {
        term.writeln("No existing name found at 0x310000");
        return null;
      }
    } catch (e) {
      console.error('Failed to read existing name from 0x310000:', e);
      term.writeln("Warning: Could not read existing board name from 0x310000");
      return null;
    }
  }

  // For older versions: try 0x150000 first, then fallback to 0x310000
  try {
    term.writeln("Reading existing board name...");

    // Read 32 bytes from the name address (to match firmware)
    const nameData = await esploader.readFlash(0x150000, 32);

    // Convert Uint8Array to string and find null terminator
    let nameString = '';
    for (let i = 0; i < nameData.length; i++) {
      const byte = nameData[i];
      if (byte === 0) break; // Null terminator found
      nameString += String.fromCharCode(byte);
    }

    // Check if we got a valid name (not empty and printable characters)
    if (nameString.length > 0 && /^[\x20-\x7E]*$/.test(nameString)) {
      term.writeln(`Found existing name: "${nameString}"`);
      return nameString;
    } else {
      term.writeln("No existing name found or name is invalid");
      term.writeln("Checking alternative address...");
    }
  } catch (e) {
    console.error('Failed to read existing name:', e);
    term.writeln("Warning: Could not read existing board name");
    term.writeln("Checking alternative address...");
  }

  try {
    // Read 32 bytes from the name address (to match firmware)
    const nameData = await esploader.readFlash(0x310000, 32);

    // Convert Uint8Array to string and find null terminator
    let nameString = '';
    for (let i = 0; i < nameData.length; i++) {
      const byte = nameData[i];
      if (byte === 0) break; // Null terminator found
      nameString += String.fromCharCode(byte);
    }

    // Check if we got a valid name (not empty and printable characters)
    if (nameString.length > 0 && /^[\x20-\x7E]*$/.test(nameString)) {
      term.writeln(`Found existing name: "${nameString}"`);
      return nameString;
    } else {
      term.writeln("No existing name found or name is invalid");
      return null;
    }
  } catch (e) {
    console.error('Failed to read existing name:', e);
    term.writeln("Warning: Could not read existing board name");
    return null;
  }
}

async function connectToDevice(autoDetect = true) {
  // Clear the terminal once, here, at the start of a user-initiated connect.
  // The ESPLoader constructor no longer clears (clean() is a no-op), so the log
  // from all the intermittent connect steps stays visible until the next connect.
  term.clear();

  // Build baud rate cascade from HTML dropdown options (fast to slow order)
  const baudRateCascade: { rate: number; name: string }[] = [];
  for (let i = 0; i < baudrates.options.length; i++) {
    const option = baudrates.options[i];
    baudRateCascade.push({
      rate: parseInt(option.value),
      name: option.text
    });
  }

  // Start with user-selected baud rate
  const selectedBaudRate = parseInt(baudrates.value);
  const startIndex = baudRateCascade.findIndex(b => b.rate === selectedBaudRate);

  // If user selected a baud rate not in cascade, start from the beginning
  const beginIndex = startIndex >= 0 ? startIndex : 0;

  updateFeedback("Connecting to board...", 'connecting', false);
  device = null; // Force re-scan

  // Port selection (only once, before baud rate attempts)
  if (autoDetect) {
    term.writeln("Attempting to auto-detect ESP32 board...");
    try {
      device = await detectESP32Port();
    } catch (e) {
      term.writeln(`Port detection failed: ${e.message}`);
      cleanUp();
      updateBoardStatus("No Board Detected", false);
      updateConnectionStatus(false);
      updateFeedback("Port detection failed", 'error', true);
      focusStep(1);
      return;
    }
  } else {
    term.writeln("Manual port selection...");
    try {
      device = await serialLib.requestPort({});
      term.writeln("Port selected manually.");
    } catch (e) {
      term.writeln(`Port selection cancelled or failed: ${e.message}`);
      cleanUp();
      updateBoardStatus("No Board Detected", false);
      updateConnectionStatus(false);
      updateFeedback("Port selection cancelled", 'error', true);
      focusStep(1);
      return;
    }
  }

  serialDevice = device; // Store the serial device reference

  // Try each baud rate starting from selected, falling back to slower speeds
  for (let i = beginIndex; i < baudRateCascade.length; i++) {
    const currentBaud = baudRateCascade[i];

    try {
      term.writeln(`Attempting connection at ${currentBaud.rate} baud (${currentBaud.name})...`);

      // Create transport with current baud rate
      transport = new Transport(device, true);
      const flashOptions = {
        transport,
        baudrate: currentBaud.rate,
        terminal: espLoaderTerminal,
        debugLogging: true,
      } as LoaderOptions;
      esploader = new ESPLoader(flashOptions);

      // Attempt connection with esploader.main()
      chip = await esploader.main();

      // Success! Update UI to show which baud rate worked
      term.writeln(`Connected successfully at ${currentBaud.rate} baud`);
      if (i > beginIndex) {
        term.writeln(`Note: Lower baud rate was needed. Consider selecting "${currentBaud.name}" for future connections.`);
        // Update the dropdown to reflect the working baud rate
        baudrates.value = currentBaud.rate.toString();
      }

      // Temporarily broken
      // await esploader.flashId();
      console.log("Settings done for :" + chip);
      lblConnTo.innerHTML = "Connected to device: " + chip;
      lblConnTo.style.display = "block";
      connectButton.style.display = "none";
      manualConnectButton.style.display = "none";
      disconnectButton.style.display = "initial";

      // Read old firmware version (requires device reset, so do this first)
      const oldVersion = await readFirmwareVersion();
      oldFirmwareVersion = oldVersion || "< v1.1.1"; // Store for telemetry (default if unable to read)
      if (oldVersion) {
        firmwareVersionDisplay.textContent = oldVersion;
        term.writeln(`Current firmware version: ${oldVersion}`);
      } else {
        // If unable to read, assume old firmware without serial output support
        firmwareVersionDisplay.textContent = "< v1.1.1";
        term.writeln("Current firmware version: < v1.1.1 (unable to detect)");
      }
      firmwareVersionLine.style.display = "flex";

      // Read and display the MAC address
      const macAddr = await readMacAddress();
      currentMacAddress = macAddr; // Store for later use (e.g., telemetry)
      if (macAddr) {
        macAddress.textContent = macAddr;
        macAddressLine.style.display = "flex";
      } else {
        macAddress.textContent = "--:--:--:--:--:--";
        macAddressLine.style.display = "none";
      }

      // Read and display the board name first
      const boardName = await readExistingBoardName();
      if (boardName) {
        updateBoardStatus(boardName, true);
        currentBoardName = boardName;
        boardIsUnnamed = false;
        boardNameEditSection.classList.remove("name-required");
      } else {
        updateBoardStatus("Unnamed Board", true, true, true);
        boardIsUnnamed = true;
        currentBoardName = "";
        boardNameEditSection.classList.add("name-required");
      }

      // Focus on step 2 when connected
      focusStep(2);

      // Update connection status only after everything is successful (this will also show the change board name button)
      updateConnectionStatus(true);

      updateFlashButtonState();

      // Show firmware action section after all reading is complete
      firmwareActionSection.style.display = "block";

      // Automatically open the board name edit section after successful connection
      showBoardNameEdit();

      // In bulk flash mode, override the name field with the current counter value
      applyBulkNameToCurrentBoard();

      updateFeedback("Connected successfully!", 'connected', false);

      // Bulk flash mode: auto-flash on connect so no manual Flash click is needed.
      if (bulkModeEnabled && bulkCurrentName) {
        term.writeln(`Bulk mode: auto-flashing "${bulkCurrentName}"...`);
        await flashFirmwareWithName();
      }
      return; // Exit successfully

    } catch (e) {
      console.error(`Failed at ${currentBaud.rate} baud:`, e);
      term.writeln(`Connection failed at ${currentBaud.rate} baud: ${e.message}`);

      // Clean up failed connection attempt
      if (transport) {
        try {
          await transport.disconnect();
        } catch (disconnectError) {
          // Ignore disconnect errors during cleanup
          console.warn("Disconnect error during cleanup:", disconnectError);
        }
      }
      transport = null;
      esploader = null;

      // If this was the last baud rate, give up
      if (i === baudRateCascade.length - 1) {
        term.writeln("");
        term.writeln("Failed to connect at any baud rate.");
        term.writeln("");
        term.writeln("Please check:");
        term.writeln("• USB cable is properly connected");
        term.writeln("• Board is powered on");
        term.writeln("• Correct port is selected");
        term.writeln("• No other program is using the serial port");

        // Handle specific serial port errors
        if (e.message.includes("Failed to open serial port") ||
          e.message.includes("InvalidStateError") ||
          e.message.includes("already open")) {
          term.writeln("");
          term.writeln("Additional troubleshooting:");
          term.writeln("• Another tab/window is using this serial port - close other instances");
          term.writeln("• Port not properly closed - disconnect USB cable and reconnect");
          term.writeln("• On Linux: wait a few seconds after disconnect before reconnecting");
          term.writeln("• Try refreshing the page and connecting again");
        }

        cleanUp();
        updateBoardStatus("No Board Detected", false);
        updateConnectionStatus(false);
        updateFeedback("Connection failed at all baud rates", 'error', true);
        hideBoardNameEdit();
        focusStep(1);
        return;
      } else {
        // Try next (slower) baud rate
        term.writeln("Retrying with slower baud rate...");
        term.writeln("");
        await new Promise(resolve => setTimeout(resolve, 500)); // Brief delay before retry
      }
    }
  }
}

connectButton.onclick = async () => {
  await connectToDevice(true);
};

manualConnectButton.onclick = async () => {
  await connectToDevice(false);
};

eraseFlashButton.onclick = async () => {
  await eraseFlashComplete();
};


async function eraseFlashComplete() {
  if (!esploader) {
    term.writeln("Error: Please connect to device first");
    updateFeedback("Error: Please connect to device first", 'error', false);
    return;
  }

  // Show confirmation dialog
  const confirmed = confirm(
    "WARNING: This will completely erase all flash memory including:\n" +
    "• Firmware\n" +
    "• Board name\n" +
    "• All stored data\n\n" +
    "Are you sure you want to continue?"
  );

  if (!confirmed) {
    term.writeln("Flash erase cancelled by user");
    return;
  }

  updateFeedback("Erasing flash memory...", 'flashing', false);

  try {
    term.writeln("Starting complete flash erase...");

    // Erase all flash
    term.writeln("Erasing all flash memory...");
    await esploader.eraseFlash();
    term.writeln("Flash memory erased successfully!");

    // Reset device
    term.writeln("Resetting device...");
    if (transport) {
      await transport.setDTR(false);
      await new Promise((resolve) => setTimeout(resolve, 100));
      await transport.setDTR(true);
    }

    term.writeln("Complete flash erase completed successfully!");
    term.writeln("Device has been completely wiped and reset.");
    updateFeedback("Flash erase completed - device is now blank", 'connected', false);

  } catch (e) {
    console.error(e);
    term.writeln(`Error during flash erase: ${e.message}`);
    updateFeedback("Flash erase failed", 'error', false);
  }
}

async function flashFirmwareWithName() {
  // Use the auto-saved board name
  const boardName = currentBoardName || "";

  if (!esploader) {
    term.writeln("Error: Please connect to device first");
    updateFeedback("Error: Please connect to device first", 'error', false);
    return;
  }

  if (!defaultBinaryData) {
    term.writeln("Error: Default binary file not loaded");
    updateFeedback("Error: Default binary file not loaded", 'error', false);
    return;
  }

  // Show progress bar and start flashing process
  updateFeedback("Starting firmware update...", 'flashing', false);
  showProgressBar();

  try {
    // Step 0: Start - Read existing board name before erasing (if no new name provided)
    updateProgress(0, 0);
    let nameToWrite = boardName;
    if (!boardName) {
      const existingName = await readExistingBoardName();
      if (existingName) {
        nameToWrite = existingName;
        term.writeln(`Will preserve existing name: "${existingName}"`);
      } else {
        term.writeln("No existing name to preserve");
      }
    }
    updateProgress(0, 100);

    // Step 1: Erasing Previous Firmware + Step 2: Flashing New Firmware
    updateProgress(1, 0);
    term.writeln("Step 1: Erasing previous firmware...");

    // Start the 10-second erasing progress simulation (stops at 99%)
    let erasingProgressInterval: NodeJS.Timeout | null = null;
    let erasingComplete = false;

    erasingProgressInterval = setInterval(() => {
      if (!erasingComplete) {
        const currentProgress = progressState.stepProgress[1];
        if (currentProgress < 99) {
          const newProgress = currentProgress + 1; // 99% over 10 seconds (100 intervals)
          updateProgress(1, newProgress);
          term.write(`Erasing firmware: ${Math.round(newProgress)}%\r`);
        }
        // Once we hit 99%, stay there until actual erase completes
      }
    }, 100); // Update every 100ms for smooth progress

    // Start the actual flashing process simultaneously
    const binaryFlashOptions: FlashOptions = {
      fileArray: [{ data: defaultBinaryData, address: 0x0 }],
      flashSize: "keep",
      eraseAll: true,
      compress: true,
      reportProgress: (fileIndex, written, total) => {
        // First time we get progress from actual flashing, the erase phase is done
        if (!erasingComplete) {
          erasingComplete = true;
          if (erasingProgressInterval) {
            clearInterval(erasingProgressInterval);
            erasingProgressInterval = null;
          }
          updateProgress(1, 100); // Complete erasing step
          term.writeln(`\nFlash erased!`);
          updateProgress(2, 0); // Start flashing step
          term.writeln("Step 2: Flashing new firmware...");
        }

        // Show real flashing progress on step 2
        const percent = Math.round((written / total) * 100);
        updateProgress(2, percent);
        term.write(`Flashing firmware: ${percent}%\r`);
      },
      calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
    } as FlashOptions;

    await esploader.writeFlash(binaryFlashOptions);

    // Clean up the interval if it's still running (shouldn't happen, but just in case)
    if (erasingProgressInterval) {
      clearInterval(erasingProgressInterval);
      erasingComplete = true;
      updateProgress(1, 100);
      term.writeln(`\nFlash erased!`);
    }

    term.writeln(`\nFirmware flashing completed successfully!`);
    updateProgress(2, 100);

    // Step 3: Writing Board Name
    updateProgress(3, 0);
    const selectedVersion = firmwareVersion.value;
    const skipNameWrite = selectedVersion === "v1.0.0";
    var nameAddress = 0x150000;

    if (skipNameWrite) {
      term.writeln("Step 3: Writing board name...");
      // Skip actual write for v1.0.0 but show progress
      updateProgress(3, 100);
      term.writeln(`\nBoard name write skipped due to legacy version v1.0.0`);
    } else if (nameToWrite) {
      if (boardName) {
        term.writeln("Step 3: Writing new board name...");
      } else {
        term.writeln("Step 3: Restoring preserved board name...");
      }

      // Convert board name to binary data (null-terminated string)
      const encoder = new TextEncoder();
      const boardNameBytes = encoder.encode(nameToWrite + '\0');

      // Create a binary string from the bytes
      let binaryString = '';
      for (let i = 0; i < boardNameBytes.length; i++) {
        binaryString += String.fromCharCode(boardNameBytes[i]);
      }

      if (selectedVersion === "v1.3.0" || selectedVersion === "v1.3.1" || selectedVersion === "v1.3.2" || selectedVersion === "v1.3.3" || selectedVersion === "v1.3.4") {
        nameAddress = 0x310000;
      }
      const boardNameFlashOptions: FlashOptions = {
        fileArray: [{ data: binaryString, address: nameAddress }],
        flashSize: "keep",
        eraseAll: false,
        compress: true,
        reportProgress: (fileIndex, written, total) => {
          const percent = Math.round((written / total) * 100);
          updateProgress(3, percent);
          term.write(`Writing board name: ${percent}%\r`);
        },
        calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
      } as FlashOptions;

      await esploader.writeFlash(boardNameFlashOptions);
      term.writeln(`\nBoard name "${nameToWrite}" written successfully!`);
      updateProgress(3, 100);
    } else {
      term.writeln("Step 3: No name to write (no existing name found and none provided)");
      updateProgress(3, 100);
    }

    // Final step: Reset the device
    term.writeln("Resetting device...");
    if (transport) {
      await transport.setDTR(false);
      await new Promise((resolve) => setTimeout(resolve, 100));
      await transport.setDTR(true);
    }
    term.writeln("Device reset completed!");
    term.writeln("You can now click 'Disconnect' to finish.");

    // send a firmware telemetry info on successful updated (if fail, ignore)
    try {
      const telemetryData = JSON.stringify({
        mac_address: currentMacAddress,
        current_firmware_version: oldFirmwareVersion,
        original_name: originalBoardName,
        new_firmware_version: firmwareVersion.value,
        new_name: currentBoardName,
        from_bulk_flashing: bulkModeEnabled
      });

      if (!IS_PRODUCTION) {
        // Non-production build: log what would have been sent, but don't post it.
        console.log("Skipping telemetry (NODE_ENV is not production):", telemetryData);
      } else {
        console.log("Sending telemetry data:", telemetryData);

        await fetch("https://control.stickem.sg/api/telemetry/firmwareHistory", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: telemetryData
        })
      }
    } catch (error) {
      console.log(error);
    }

    // Bulk flash mode: advance the counter ONLY on a successful flash.
    // A failed flash throws before reaching here, so the name is preserved.
    if (bulkModeEnabled && bulkCurrentName) {
      const flashedName = bulkCurrentName;
      bulkCurrentName = incrementBulkName(bulkCurrentName);
      bulkStartSuffix.value = bulkSuffixFromName(bulkCurrentName);
      updateBulkNextNameDisplay();
      term.writeln(`Bulk mode: "${flashedName}" flashed. Next board will be "${bulkCurrentName}".`);
    }

    // This flash has been recorded, so pull the "last flashed board" panel back
    // in sync. Not awaited - it must not hold up the success messages.
    refreshLastFlashedBoard();

    // Success messages
    if (boardName) {
      term.writeln("Flash & Write Board Name completed successfully!");
      updateFeedback("You can now physically disconnect the board!", 'connected', false);
    } else if (nameToWrite) {
      term.writeln("Firmware update with name preservation completed successfully!");
      updateFeedback("You can now physically disconnect the board!", 'connected', false);
    } else {
      term.writeln("Firmware update completed successfully!");
      updateFeedback("You can now physically disconnect the board!", 'connected', false);
    }

    // Hide the board name edit section after successful flash
    hideBoardNameEdit();

    // Update the board name display
    if (nameToWrite) {
      updateBoardStatus(nameToWrite, true);
    }

    // Hide progress bar immediately since feedback shows completion
    hideProgressBar();

    // Auto-disconnect immediately
    term.writeln("Auto-disconnecting...");
    if (transport) {
      try {
        await transport.disconnect();
        term.writeln("Device disconnected successfully.");
      } catch (e) {
        console.warn("Disconnect error (cable may have been unplugged):", e.message);
        term.writeln("Device was already disconnected (cable unplugged?)");
      }
    }

    term.writeln("Ready for next connection.");
    connectButton.style.display = "initial";
    manualConnectButton.style.display = "initial";
    disconnectButton.style.display = "none";
    firmwareActionSection.style.setProperty("display", "none", "important");

    hideBoardNameEdit();
      lblConnTo.style.display = "none";
    alertDiv.style.display = "none";
    cleanUp();

    // Reset board status and name variables
    updateBoardStatus("No Board Detected", false);
    updateConnectionStatus(false);
    firmwareVersionLine.style.display = "none";
    macAddressLine.style.display = "none";
    currentMacAddress = null;
    oldFirmwareVersion = null;
    currentBoardName = null;
    originalBoardName = null;
    boardIsUnnamed = false;
    boardNameInput.disabled = false;
    flashFirmwareButton.disabled = false;
    boardNameEditSection.classList.remove("name-required");

    // Focus back on step 1 when disconnected
    focusStep(1);

  } catch (e) {
    console.error(e);
    term.writeln(`Error during firmware update: ${e.message}`);
    updateFeedback("Firmware update failed", 'error', false);
    hideProgressBar();
  }
}



/**
 * Clean devices variables on chip disconnect. Remove stale references if any.
 */
function cleanUp() {
  device = null;
  serialDevice = null;
  transport = null;
  chip = null;
}

disconnectButton.onclick = async () => {
  if (transport) {
    try {
      // Perform DTR reset before disconnecting
      await transport.setDTR(false);
      await new Promise((resolve) => setTimeout(resolve, 100));
      await transport.setDTR(true);
      term.writeln("Device reset completed.");

      await transport.disconnect();
      term.writeln("Device disconnected successfully.");
    } catch (e) {
      console.warn("Disconnect error (cable may have been unplugged):", e.message);
      term.writeln("Device was already disconnected (cable unplugged?)");
    }
  }

  term.writeln("Ready for next connection.");
  connectButton.style.display = "initial";
  manualConnectButton.style.display = "initial";
  disconnectButton.style.display = "none";
  firmwareActionSection.style.display = "none";

  hideBoardNameEdit();
  hideProgressBar();
  lblConnTo.style.display = "none";
  alertDiv.style.display = "none";
  cleanUp();

  // Reset board status and name variables
  updateBoardStatus("No Board Detected", false);
  updateConnectionStatus(false);
  updateFeedback("Ready to connect...", 'default', false);
  firmwareVersionLine.style.display = "none";
  macAddressLine.style.display = "none";
  currentMacAddress = null;
  oldFirmwareVersion = null;
  currentBoardName = null;
  originalBoardName = null;
  boardIsUnnamed = false;
  boardNameInput.disabled = false;
  flashFirmwareButton.disabled = false;

  // Focus back on step 1 when disconnected
  focusStep(1);
};

// Force Disconnect button (for emergency use during firmware update)
forceDisconnectButton.onclick = async () => {
  // Use the same disconnect logic as the regular disconnect button
  if (transport) {
    try {
      // Perform DTR reset before disconnecting
      await transport.setDTR(false);
      await new Promise((resolve) => setTimeout(resolve, 100));
      await transport.setDTR(true);
      term.writeln("Device reset completed.");

      await transport.disconnect();
      term.writeln("Device disconnected successfully.");
    } catch (e) {
      console.warn("Disconnect error (cable may have been unplugged):", e.message);
      term.writeln("Device was already disconnected (cable unplugged?)");
    }
  }

  term.writeln("Ready for next connection.");
  connectButton.style.display = "initial";
  manualConnectButton.style.display = "initial";
  disconnectButton.style.display = "none";
  firmwareActionSection.style.display = "none";

  hideBoardNameEdit();
  hideProgressBar();
  lblConnTo.style.display = "none";
  alertDiv.style.display = "none";
  cleanUp();

  // Reset board status and name variables
  updateBoardStatus("No Board Detected", false);
  updateConnectionStatus(false);
  updateFeedback("Ready to connect...", 'default', false);
  firmwareVersionLine.style.display = "none";
  macAddressLine.style.display = "none";
  currentMacAddress = null;
  oldFirmwareVersion = null;
  currentBoardName = null;
  originalBoardName = null;
  boardIsUnnamed = false;
  boardNameInput.disabled = false;
  flashFirmwareButton.disabled = false;

  // Focus back on step 1 when disconnected
  focusStep(1);
};




// Initialize default binary loading and set current firmware version
currentFirmwareVersion = firmwareVersion.value; // Set to whatever is selected by default in HTML
loadDefaultBinary();

// Check Web Serial API support now that DOM elements are ready
checkWebSerialSupport();
